module.exports = __webpack_public_path__ + "static/img/world_innovator_07.f5701df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/world_innovator_07.jpg
// module id = 165
// module chunks = 1